import React from 'react';
import { Wrench, Facebook, Instagram, Linkedin } from 'lucide-react';
import { navLinks, contactInfo } from '../../data/mock';

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center">
                <img src="/assets/gt-logo.png" alt="GT Assistenza Tecnica Taccone" className="w-9 h-9 object-contain" />
              </div>
              <div className="leading-tight">
                <div className="font-extrabold tracking-tight text-white text-lg">GT Assistenza</div>
                <div className="text-[11px] uppercase tracking-[0.18em] text-sky-400">Tecnica Taccone</div>
              </div>
            </div>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">Centro di assistenza tecnica multimarca dal 1996. Riparazione, consulenza e gestione IT per privati e aziende.</p>
            <div className="mt-5 flex gap-2">
              {[Facebook, Instagram, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-sky-600 flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-white font-bold mb-4">Navigazione</div>
            <ul className="space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}><a href={l.href} className="text-sm hover:text-sky-400 transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-white font-bold mb-4">Servizi</div>
            <ul className="space-y-2.5 text-sm">
              <li>Riparazione PC & Notebook</li>
              <li>Riparazione Smartphone</li>
              <li>Assistenza TV & Audio</li>
              <li>Reti aziendali & sicurezza</li>
              <li>Recupero dati</li>
              <li><a href="https://www.iperiusremote.com/download.aspx" target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:text-emerald-300 font-medium">→ Assistenza remota (Iperius)</a></li>
              <li><a href="https://www.dhl.com/it-it/home.html" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:text-yellow-300 font-medium">→ Punto di ritiro DHL</a></li>
            </ul>
          </div>

          <div>
            <div className="text-white font-bold mb-4">Contatti</div>
            <ul className="space-y-2.5 text-sm">
              <li>{contactInfo.address}</li>
              <li>{contactInfo.city}</li>
              <li><a href={`tel:${contactInfo.phone.replace(/\s/g,'')}`} className="hover:text-sky-400">{contactInfo.phone}</a></li>
              <li>
                <a href={`https://wa.me/${contactInfo.whatsappRaw}?text=${encodeURIComponent(contactInfo.whatsappMessage)}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-green-400 hover:text-green-300 font-medium">
                  <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" /></svg>
                  WhatsApp {contactInfo.whatsapp}
                </a>
              </li>
              <li><a href="mailto:info@gtassistenza.it" className="hover:text-sky-400">info@gtassistenza.it</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 grid md:grid-cols-2 gap-6 items-center">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-sky-400 font-bold">Pagamenti accettati</div>
            <p className="mt-2 text-sm text-slate-400">Accettiamo contanti, carte di credito/debito e i principali metodi di pagamento digitali.</p>
          </div>
          <div className="flex flex-wrap items-center gap-3 md:justify-end">
            <a href="https://www.paypal.com" target="_blank" rel="noopener noreferrer" aria-label="PayPal" className="h-12 px-5 rounded-xl bg-white flex items-center justify-center hover:scale-105 transition-transform shadow-md">
              <img src="/assets/paypal.svg" alt="PayPal" className="h-6 w-auto" />
            </a>
            <a href="https://www.satispay.com" target="_blank" rel="noopener noreferrer" aria-label="Satispay" className="h-12 px-5 rounded-xl bg-white flex items-center justify-center hover:scale-105 transition-transform shadow-md">
              <img src="/assets/satispay.svg" alt="Satispay" className="h-6 w-auto" />
            </a>
            <div className="h-12 px-5 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-slate-200 text-sm font-semibold">
              <svg viewBox="0 0 24 24" className="w-4 h-4 mr-2 fill-current" aria-hidden="true"><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>
              Carte
            </div>
            <div className="h-12 px-5 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-slate-200 text-sm font-semibold">Contanti</div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} GT Assistenza Tecnica Taccone</div>
          <div className="flex gap-5 flex-wrap">
            <a href="#" className="hover:text-sky-400">Privacy Policy</a>
            <a href="#" className="hover:text-sky-400">Cookie Policy</a>
            <button type="button" onClick={() => window.dispatchEvent(new Event('open-cookie-preferences'))} className="hover:text-sky-400 cursor-pointer">Preferenze cookie</button>
            <a href="#" className="hover:text-sky-400">Termini</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
